import { render, staticRenderFns } from "./UserSearchResultsContainer.vue?vue&type=template&id=bfe18e14&scoped=true&"
import script from "./UserSearchResultsContainer.vue?vue&type=script&lang=js&"
export * from "./UserSearchResultsContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchResultsContainer.vue?vue&type=style&index=0&id=bfe18e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe18e14",
  null
  
)

export default component.exports